export const getExternalUrl = (
  originalUrl?: string | null
): string | undefined => {
  return originalUrl
    ? originalUrl.match(/^http?:\/\//i) || originalUrl.match(/^https?:\/\//i)
      ? originalUrl
      : 'http://' + originalUrl
    : undefined;
};
